import React, { FC, memo, RefObject } from 'react';
import styled from '@emotion/styled';
import { EposMenuCategory } from '../../../types';
import CategoryButton from './CategoryButton';

const Rail = styled.nav`
  /* Width and padding come from styles/index.css - narrower on small screens. */
  flex: 0 0 var(--eposRailWidth);
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: var(--eposPrimary);
  padding: var(--eposRailPadding);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--eposRailGap);

  &::-webkit-scrollbar {
    display: none;
  }
`;

interface Props {
  categories: EposMenuCategory[];
  onSelect: (categoryId: string) => void;
  /** The rail element, so the scroll-spy can find buttons by data-category-id. */
  containerRef: RefObject<HTMLElement>;
}

const CategoryRail: FC<Props> = ({ categories, onSelect, containerRef }) => (
  <Rail ref={containerRef}>
    {categories.map((category) => (
      <CategoryButton key={category.id} category={category} onSelect={onSelect} />
    ))}
  </Rail>
);

export default memo(CategoryRail);
